import { render } from "./DropDownGroup.vue?vue&type=template&id=47cdee58"
import script from "./DropDownGroup.vue?vue&type=script&lang=js"
export * from "./DropDownGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__